import React from "react";
import Button from "components/BaseWidgets/button";
import { Cancel, DisableIcon, WhiteTick } from "assets/icons";
import { useMessageRequestStatus } from "hooks/api/useMessageRequestStatus";

const MessageRequest = ({ selectedThread, refetch }) => {
  const { mutate: updateMessageStatus } = useMessageRequestStatus();

  const handleStatusUpdate = async (status) => {
    updateMessageStatus({
      //message
      aec_id: selectedThread?.recipient_aec,
      status,
    }, {
      onSuccess: async () => {
        await refetch()
      }
    });


  };

  return (
    <div className="message-request-wrapper">
      <div className="request-text">
        <p className="title">
          Accept message request from {selectedThread?.recipient_name}?
        </p>
        <p className="subtitle">
          If you accept, they will be able to call you and see all your
          information.
        </p>
      </div>

      {/* BUTTON SECTION */}
      <div className="message-request-actions">
        {/* <Button
                    variant="tertiary"
                    className="action-button"
                //   onClick={onBlock}
                ><DisableIcon />
                    <span> Block</span>
                </Button> */}

        <Button
          variant="tertiary"
          className="action-button"
          onClick={() => handleStatusUpdate(3)}
        >
          <Cancel />
          <span>Reject</span>
        </Button>

        <Button
          variant="primary"
          className="action-button"
          onClick={() => handleStatusUpdate(2)}
        >
          <WhiteTick />
          <span>Accept</span>
        </Button>
      </div>
    </div>
  );
};

export default MessageRequest;
